import { NavigationAction, NavigationActionType } from "../actions/navigation";

export type NavigationState = {
    routeStack: string[];
}

const initState: NavigationState = {
    routeStack: []
}

export const navigationReducer = (
    prevState: NavigationState = initState,
    action: NavigationAction): NavigationState => {
        switch (action.type) {
            case NavigationActionType.INIT:
                return { routeStack: [ ...action.routes ] }

            case NavigationActionType.POP:
                return { routeStack: prevState.routeStack.length > 0 ?
                            prevState.routeStack.slice(0, -1) : [] }
            
            case NavigationActionType.PUSH:
                return { routeStack: [ ...prevState.routeStack, action.route ] }
            
            case NavigationActionType.REPLACE:
                return { routeStack: prevState.routeStack.length > 0 ? 
                    [ ...prevState.routeStack.slice(0, -1), action.route ]
                    : [ action.route ]
                }
        
            default:
                break;
        }
        return prevState;
}
